<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <loading
        :active.sync="cargando"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-card class="bCardGlobalXL">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="10">
          <div>
            <p class="textoSubtitulo">Padecimientos</p>
          </div>
        </b-col>
        <b-col cols="6" md="2">
          <div>
            <p style="text-align: end" class="textoSubtitulo">Px_01_cdx</p>
          </div>
        </b-col>
      </b-row>

      <b-row class="text-center mt-4">
        <b-col cols="1" md="3">
        </b-col>

        <b-col cols="9" md="6" >
          <b-row class="contenedorTablaSinColor" style="background:white ">
            <b-col cols="10" lg="11" class="pr-0">
              <b-input-group class="pl-3" >
                <b-form-input
                    class="input-filter"
                    v-model="filtro.palabraClave"
                    type="search"
                    id="filterInput"
                    responsive
                    name="nombre"
                    placeholder="Nombre del padecimiento"
                    @keydown.enter.native="obtenerPadecimientos"
                >
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="2" lg="1" class="pl-0">
              <b-button
                  class="mt-1 pb-1"
                  size="sm"
                  variant="info"
                  @click="obtenerPadecimientos"
                  responsive
              >
                <span
                >
                  <em class="buscar_svg primary sm"></em>
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="1" class="text-left mt-auto mb-auto" v-if="$localStorageService.can('Px_01_catalog_alta_px')">
          <b-button
              variant="primary"
              v-b-tooltip.hover
              title="Crear padecimiento"
              class="paddingbotones botonesAzulFuerte"
              @click="agregar"
              responsive
          ><em class="padecimiento_icono icon-boton"></em>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
          <b-table
              :hover="true"
              :small="true"
              style="font-size: 12px !important; padding: 0.1rem;"
              responsive
              fixed
              :fields="fields"
              :items="datosTabla"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              thead-tr-class="columnasTablaSinColorLetter"
              id="Pendientes"
              class="parrafos"
          >
            <template v-slot:cell(listaPx)="row">
              <span v-if="row.item.tieneTratameintos == true">
                <b-icon icon="check" style="color: green;" font-scale="3"></b-icon>
              </span>
              <span v-else>
                <b-icon icon="x" style="color: red;" font-scale="3"></b-icon>
              </span>
            </template>
            <template v-slot:cell(Acciones)="row">
                <b-button
                    v-if="
                      row.item.bloqueoSistema &&
                      $localStorageService.can('Px_01_catalog_mod_px')"
                    title="Consultar padecimiento"
                    size="sm"
                    @click="modificar(row.item)"
                    variant="outline-secondary"
                ><em class="fa fa-lock"></em
                ></b-button>
                <b-button
                    v-if="
                      !row.item.bloqueoSistema &&
                      $localStorageService.can('Px_01_catalog_mod_px') && row.item.registroActivo"
                    title="Modificar padecimiento"
                    @click="modificar(row.item)"
                    variant="outline-warning"
                    size="m"
                    class="mr-1 mt-1 marginbotones"
                    style="max-width: 2vw"
                ><em class="fa fa-pencil icon-boton"></em
                ></b-button>
                <b-button
                    v-if="
                    !row.item.bloqueoSistema &&
                    !row.item.registroActivo &&
                    $localStorageService.can('Px_01_catalog_act_px')
                  "
                    title="Activar padecimiento"
                    variant="outline-success"
                    size="sm"
                    class="mr-1 mt-1 marginbotones"
                    style="max-width: 2vw"
                    @click="eliminar(row.item)"
                ><em class="fa fa-undo"></em
                ></b-button>
                <b-button
                    v-if="
                    !row.item.bloqueoSistema &&
                    row.item.registroActivo &&
                    $localStorageService.can('Px_01_catalog_baj_px')
                  "
                    title="Eliminar padecimiento"
                    variant="danger"
                    size="m"
                    class="mr-1 mt-1 marginbotones"
                    style="max-width: 2vw"
                    @click="eliminar(row.item)"
                >
                  <em class="eliminar_svg icon-boton"></em>
                </b-button>
            </template>
            <template v-slot:cell(validacion)="row">
              <span v-if="row.item.validacion == true">
                <b-icon icon="check" style="color: green;" font-scale="3"></b-icon>
              </span>
              <span v-else>
                <b-icon icon="x" style="color: red;" font-scale="3"></b-icon>
              </span>
            </template>

            <template v-slot:cell(od)="row">
              <span v-if="row.item.od == true">
                <b-icon icon="check" style="color: green;" font-scale="3"></b-icon>
              </span>
              <span v-else>
                <b-icon icon="x" style="color: red;" font-scale="3"></b-icon>
              </span>
            </template>

            <template v-slot:cell(ordenAparicion)="row">
              <span v-if="row.item.ordenAparicion == null"> - </span>
              <span v-else>
                {{ row.item.ordenAparicion }}
              </span>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show
            >No hay datos
            </b-alert
            >
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-card>

    <!--Modal inicial-Editar tratamiento -->
    <b-modal
        v-model="show"
        size="xl"
        hide-footer
    >
      <b-container fluid>
        <b-row style="font-size: x-large" class="ml-1">
          <em class="correoAzul primary sm"></em>
          <span style="font-weight: bold;" class="textoSubtitulo">Nuevo padecimiento</span>
        </b-row>
        <br>
        <b-row>
          <b-col>
            <span style="font-weight: bold; color: var(--color-dentalia);">Nuevo padecimiento</span>
            <b-tabs align="right" pills>
              <b-tab title="Padecimiento">
                <b-form>
                  <b-form-group align="left" :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema">
                    <b-row>
                      <b-col cols="4">
                        <span>Nombre del padecimiento</span>
                        <b-form-input
                          id="nombrePadecimiento"
                          name="nombrePadecimiento"
                          placeholder="Escribe el nombre del padecimiento"
                          v-model="$v.padecimiento.descripcion.$model"
                          :state="validateState('descripcion')"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="8" class="mt-4 pt-2">
                        <b-row>
                          <b-col cols="2" class="pr-0 row">
                            <span class="mr-2">Por diente</span>
                            <b-form-checkbox v-model="$v.padecimiento.od.$model" :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                            ></b-form-checkbox>
                          </b-col>
                          
                          <b-col cols="2" class="pr-0 row">
                            <span class="mr-2">Cuadrante</span>
                            <b-form-checkbox :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                              v-model="$v.padecimiento.cuadrante.$model"
                            ></b-form-checkbox>
                          </b-col>

                          <b-col cols="2" class="pr-0 row">
                            <span class="mr-2">Arcada</span>
                            <b-form-checkbox v-model="$v.padecimiento.arcada.$model" :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                            ></b-form-checkbox>
                          </b-col>

                          <b-col cols="2" class="pr-0 row">
                            <span class="mr-2">Boca</span>
                            <b-form-checkbox v-model="$v.padecimiento.boca.$model" :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                            ></b-form-checkbox>
                          </b-col>

                          <b-col cols="2" class="pr-0 row">
                            <span class="mr-2">Ortodoncia</span>
                            <b-form-checkbox :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                              v-model="$v.padecimiento.ortodoncia.$model"
                            ></b-form-checkbox>
                          </b-col>

                          <b-col cols="2" class="pr-0 row">
                            <span class="mr-2">Requerido</span>
                            <b-form-checkbox :disabled="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                              v-model="$v.padecimiento.validacion.$model"
                            ></b-form-checkbox>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-form-group>

                  <hr/>
                  <div class="mt-2 col-md-12"></div>

                  <b-row>
                    <b-col><h3 style="color: var(--color-dentalia-v2)">Tratamientos de sugerencia</h3></b-col>
                    <b-col class="text-right">
                      <b-button
                          v-if="padecimiento.bloqueoSistema === undefined || padecimiento.bloqueoSistema === null || !padecimiento.bloqueoSistema"
                          size="m"
                          variant="link"
                          @click="modalTratamientoNuevo()"
                          title="Agregar tratamiento"
                          v-b-tooltip.hover
                      ><font-awesome-icon icon="plus-circle"/>
                      </b-button>
                    </b-col>
                    <hr>
                  </b-row>

                  <b-row v-if="fieldsDienteVistaModal !== undefined && fieldsDienteVistaModal != null">
                    <b-col cols="4" v-for=" (p,index) in fieldsDienteVistaModal" :key="index+'PRESUNTIVO'+ p.presuntivo ">
                      <b-card
                          align="center"
                          class="text-center"
                          style="border-radius: 15px; border-color: lightblue;"
                      >
                        <b-card-text>
                          <div class="d-flex justify-content-center align-items-center">
                            <span style="font-weight: bold; color: var(--color-dentalia)">PRESUNTIVO {{ p.presuntivo }}</span>
                          </div>

                          <div class="accordion" role="tablist" v-if="p.tratamientos !== undefined && p.tratamientos !== null && p.tratamientos.length > 0 && p.tratamientos[0] !== null">
                            <draggable
                                :list="p.tratamientos"
                                :disabled="!enabled && padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema"
                                class="list-group"
                                ghost-class="ghost"
                                @start="dragging = true"
                                @end="dragging = false"
                            >
                              <div v-for="(t,ind) in p.tratamientos"
                                  :key="t != null ? t.idTratamiento : 0+'p'+index+'t'+ind+'key'">
                                <div class="mb-1" v-if="t !== null">
                                    <b-row style="width: 100%">

                                      <b-col style="width: auto">
                                        <div class="d-flex">
                                              <span class="text-left">
                                                <b-badge v-if="t.idDenticion === 1" pill
                                                        variant="primary">{{ t.denticion }}</b-badge>
                                                <b-badge v-if="t.idDenticion === 2" pill
                                                        variant="primary">{{ t.denticion }}</b-badge>
                                                <b-badge v-if="t.idDenticion === 3" pill
                                                        variant="warning">{{ t.denticion }}</b-badge>
                                                <b-badge v-if="t.idKit !== null" pill
                                                        variant="success">Kit</b-badge>
                                              </span>
                                          <span class="text-center w-100">
                                                {{ t.nombreTratamiento }}
                                              </span>
                                        </div>
                                      </b-col>
                                      <b-button v-if="t.idKit !== null" pill v-b-toggle="t.idTratamiento+'p'+index+'t'+ind" @click="t.collapseOpen = !t.collapseOpen"
                                        variant="outline-info" size="sm" class="mr-1 mt-1 marginbotones" style="max-width: 2vw; max-height: 2vw;">
                                        <b-icon icon="chevron-down" font-scale="1.1" :rotate="t.collapseOpen ? 180 : 0"></b-icon>
                                      </b-button>
                                      <b-button v-if="padecimiento.bloqueoSistema === undefined || padecimiento.bloqueoSistema === null || !padecimiento.bloqueoSistema"
                                          variant="outline-warning" class="mr-1 mt-1 marginbotones" style="max-width: 2vw; max-height: 2vw;" size="sm">
                                          <em class="editar_svg_amarillo icon-boton" @click="modificarTratamiento(p,t)"></em>
                                      </b-button>
                                      <b-button v-if="padecimiento.bloqueoSistema === undefined || padecimiento.bloqueoSistema === null || !padecimiento.bloqueoSistema"
                                          variant="outline-danger" class="mr-1 mt-1 marginbotones" style="max-width: 2vw; max-height: 2vw;" size="sm">
                                          <b-icon icon="trash-fill" @click="eliminarLista(p,t)"></b-icon>
                                      </b-button>
                                    </b-row>

                                  <b-collapse :id="t.idTratamiento+'p'+index+'t'+ind" accordion="my-accordion"
                                              role="tabpanel">
                                    <b-row class="ml-2 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in t.listaTratamientos" :key="indexTratamiento">
                                      <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                                      <b-col align="left"><span>{{ trt.nombreTratamiento }}</span></b-col>
                                      <b-col cols="1"><span>{{ trt.cantidad }}</span></b-col>
                                    </b-row>
                                  </b-collapse>
                                </div>
                              </div>
                            </draggable>
                          </div>
                          <div v-else style="height: 400px;" class="d-flex justify-content-center align-items-center">
                            Sin tratamientos agregados
                          </div>
                        </b-card-text>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-form>
              </b-tab>
              <b-tab title="Motivo cita">
                  <span style="color: var(--color-dentalia-v2);">Nuevo motivo Cita por Clasificación Clínica</span>
                    <validation-observer ref="observer" v-slot="{ handleSubmit }">
                      <b-form ref="formAgregarMotivoEtapa"
                              @submit.stop.prevent="
                      handleSubmit(
                        agregarElementosAlSArrayPadecimientoMotivoTagEtapa(
                          idTagMotivoCita,
                          idClasificacionClinica,
                        )
                      )
                    "
                      >
                        <div class="row">
                          <div class="col-4" align="left">
                            <label class="letraEstiloNegrita">Limitar clasificación clínica</label>
                            <b-form-checkbox switch v-model="padecimiento.limitarClasificacion"
                            ></b-form-checkbox>
                          </div>
                        </div>
                        <div class="row">

                          <div class="col-4" align="left">
                            <label class="letraEstiloNegrita">Motivo Cita</label>
                            <validation-provider
                                name="validacionidTagMotivoCita"
                                :rules="{ required: true }"
                                v-slot="errors"
                            >
                              <b-form-select
                                  class="parrafos"
                                  size="sm parrafos"
                                  v-model="idTagMotivoCita"
                              >
                                <b-form-select-option
                                    v-for="elem in tagmotivocitaDatosArray"
                                    :key="elem.idTagMotivoCita"
                                    :value="elem.idTagMotivoCita"
                                >{{ elem.descripcionTagMotivoCita }}
                                </b-form-select-option>
                              </b-form-select>
                              <validacion
                                  :texto="errors.errors[0] ? errors.errors[0] : ' '"
                              ></validacion>
                            </validation-provider>
                          </div>


                          <div class="col-4" align="left">
                            <label class="letraEstiloNegrita">Clasificación clínica</label>
                            <validation-provider
                                name="validacionidClasificacionClinica"
                                :rules="{ required: true }"
                                v-slot="errors"
                            >
                              <b-form-select
                                  class="parrafos"
                                  size="sm parrafos"
                                  v-model="idClasificacionClinica"
                                  v-if="!padecimiento.limitarClasificacion"
                              >
                                <b-form-select-option
                                    v-for="elem in clasificacionClinicas"
                                    :key="elem.idClasificacionClinica"
                                    :value="elem.idClasificacionClinica"
                                >{{ elem.clasificacionClinica }}
                                </b-form-select-option>
                              </b-form-select>
                              <b-form-select
                                  class="parrafos"
                                  size="sm parrafos"
                                  v-model="idClasificacionClinica"
                                  v-else
                              >
                                <b-form-select-option
                                    v-for="elem in clasificacionLimitada"
                                    :key="elem.idClasificacionClinica"
                                    :value="elem.idClasificacionClinica"
                                >{{ elem.clasificacionClinica }}
                                </b-form-select-option>
                              </b-form-select>
                              <validacion
                                  :texto="errors.errors[0] ? errors.errors[0] : ' '"
                              ></validacion>
                            </validation-provider>
                          </div>
                          <div class="col-4 mt-4" align="left">
                              <b-button type="submit" variant="outline-info" pill>Aplicar</b-button>
                      </div>
                      </div>

                      <br/>

                      </b-form>
                    </validation-observer>

                  <div class="row">
                    <div class="col-12" align="left">
                      <br/><br/>
                      <b-table
                          :hover="true"
                          :small="true"
                          style="font-size: 12px !important; padding: 0.1rem;"
                          responsive
                          fixed
                          id="Pendientes"
                          thead-tr-class="columnasTablaSinColorLetter"
                          :items="arrayPadecimientoMotivoTagEtapa"
                          :fields="layoutTablaArrayPadecimientoMotivoTagEtapa"
                      >

                        <template v-slot:cell(eliminar)="row">
                          <b-button title="Eliminar"
                                    variant="outline-danger"
                                    class="mr-1 mt-1 marginbotones" 
                                    style="max-width: 2vw; max-height: 2vw;" size="sm"
                                    align="center"
                                    @click="eliminarElementosAlSArrayPadecimientoMotivoTagEtapa(row.item)"
                                    v-if="padecimiento.bloqueoSistema === undefined || padecimiento.bloqueoSistema === null || !padecimiento.bloqueoSistema">
                            <b-icon icon="trash-fill"></b-icon>
                          </b-button>
                          <br/><br/>
                        </template>
                      </b-table>
                      <div v-if="arrayPadecimientoMotivoTagEtapa.length == 0" style="height: 150px;" class="d-flex justify-content-center align-items-center">
                        <span>Sin motivos de cita agregados</span>
                      </div>
                    </div>
                  </div>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
        <br>
        <b-row class="mt-4">
          <b-col style="text-align: right;">
            <b-button
                variant="primary" pill
                :disabled="loaderAcciones || (padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema)"
                @click="guardar()"
            >
              <span v-if="!loaderAcciones">Guardar</span>
              <span v-if="loaderAcciones">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
              <span v-if="padecimiento.bloqueoSistema !== undefined && padecimiento.bloqueoSistema !== null && padecimiento.bloqueoSistema">
                &nbsp;<em class="fa fa-lock"></em>
              </span>
            </b-button>
          </b-col>
          <b-col style="text-align: left;">
            <b-button
                pill
                variant="outline-secondary"
                :disabled="loaderAcciones"
                @click="cerrarModal()"
            >Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <!-- Tratamiento Nuevo Modal-->
    <b-modal
        v-model="mostrarModalTratamientoNuevo"
        :title="tituloModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <fieldset>
                <b-row>
                  <b-col>
                    <label class="labels" style="margin-left: 5px; margin-bottom: 0px;">Tratamiento</label>
                    <SelectTratamientos
                        style="width: 100%;"
                        :indexPadecimiento="1"
                        :indexOpcion="1"
                        :catalogoTratamientos="listaTratamientos"
                        :catalogokits="listaKits"
                        :idSeleccionado="listaAgregar.idTratamiento"
                        :tratamiento="listaAgregar"
                        :i="1"
                        :kits="true"
                    ></SelectTratamientos>
                  </b-col>
                  <b-col>
                    <label class="labels" style="margin-left: 5px; margin-bottom: 12px;">Tipo paciente</label>
                    <v-select
                        placeholder="Tipo paciente"
                        v-model="listaAgregar.idAdlNnMix"
                        label="text"
                        :options="tipoDenticion"
                    ></v-select>
                  </b-col>
                </b-row>
                
                <br>
                <label class="labels" style="margin-left: 5px;">Diente(s)</label>
                <v-select
                    placeholder="Diente"
                    v-model="listaAgregar.idDiente"
                    label="text"
                    :reduce="(variable) => variable.idDiente"
                    :options="listaAgregar.idAdlNnMix === null? []: opciones.filter(o => listaAgregar.idAdlNnMix.idTip === 3 || o.idDenticion ===  listaAgregar.idAdlNnMix.idTip || o.idDenticion === 3)"
                    multiple
                ></v-select>

                <br>
                <label class="labels" style="margin-left: 5px;">Nivel Pti Presuntivo</label>
                <v-select
                    placeholder="Presuntivo"
                    v-model="listaAgregar.idPresuntivo"
                    label="text"
                    :options="opcionesPti"
                    :reduce="(variable) => variable.value"
                    multiple
                ></v-select>
              </fieldset>
            </b-form>
          </b-col>
        </b-row>
        <br>
        <b-row class="mt-4">
          <b-col style="text-align: right;">
            <b-button
              variant="primary"
              :disabled="loaderAcciones"
              pill
              @click="AgregarLista()"
            >
              <span v-if="!loaderAcciones">Aplicar</span>
              <span v-if="loaderAcciones">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
            </b-button>
          </b-col>
          <b-col style="text-align: left;">
            <b-button
              style="margin-left: 2px"
              variant="outline-secondary"
              :disabled="loaderAcciones"
              pill
              @click="cerrarModalTratamientos()"
            >Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
        v-model="modalModificar"
        title="Modificar Tratamiento"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
    >
    <b-container fluid>
        <b-row>
          <b-col>
            <label class="labels" style="margin-left: 5px; margin-bottom: 0px;">Tratamiento</label>
            <SelectTratamientos
                style="width: 100%;"
                :indexPadecimiento="1"
                :indexOpcion="1"
                :catalogoTratamientos="listaTratamientos"
                :catalogokits="listaKits"
                :idSeleccionado="tratamientoSeleccionado.idTratamiento"
                :tratamiento="tratamientoSeleccionado.tratamiento"
                :i="1"
                :kits="true"
            ></SelectTratamientos>
          </b-col>
          <b-col>
            <label class="labels" style="margin-left: 5px; margin-bottom: 12px;">Tipo paciente</label>
            <v-select
                placeholder="Tipo paciente"
                v-model="tratamientoSeleccionado.tipoDenticion"
                label="text"
                :options="tipoDenticion"
            ></v-select>
          </b-col>
        </b-row>
        
        <br>
        <label class="labels" style="margin-left: 5px;">Diente(s)</label>
        <v-select
            placeholder="Diente"
            v-model="tratamientoSeleccionado.dientes"
            label="text"
            :reduce="(variable) => variable.idDiente"
            :options="tratamientoSeleccionado.tipoDenticion === null? []: opciones.filter(o => tratamientoSeleccionado.tipoDenticion.idTip === 3 || o.idDenticion ===  tratamientoSeleccionado.tipoDenticion.idTip || o.idDenticion === 3)"
            multiple
        ></v-select>

        <br/>
        <label class="labels" style="margin-left: 5px;">Nivel Pti Presuntivo</label>
        <v-select
            placeholder="Presuntivo"
            v-model="tratamientoSeleccionado.idPresuntivo"
            label="text"
            :options="opcionesPti"
            :reduce="(variable) => variable.value"
            multiple
        ></v-select>
        <br>
        <b-row class="mt-4">
          <b-col style="text-align: right;">
            <b-button
              variant="primary"
              :disabled="loaderAcciones"
              @click="actualizarRegistro()"
              pill
            >
              <span v-if="!loaderAcciones">Actualizar</span>
              <span v-if="loaderAcciones">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
            </b-button>
          </b-col>
          <b-col style="text-align: left;">
            <b-button
              style="margin-left: 2px"
              variant="outline-secondary"
              :disabled="loaderAcciones"
              @click="cerrarModalTratamientos()"
              pill
            >Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {numeric, required} from "vuelidate/lib/validators";
import miniToastr from "mini-toastr";
import draggable from "vuedraggable";
import SelectTratamientos from '../../version5/diagnostico/SelectTratamientos.vue';

export default {
  components: {
    Header,
    draggable,
    SelectTratamientos

  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      layoutTablaArrayPadecimientoMotivoTagEtapa: [
        /*{
          key: "nombreTipoTag",
          label: "Flujo PX",
          sortable: true,
        },
        {
          key: "nombreDenticion",
          label: "Dentición",
          sortable: true,
        },*/
        {
          key: "nombreMotivoCita",
          label: "Motivo Cita",
          sortable: true,
        },
        {
          key: "nombreClasificacion",
          label: "Clasificación clinica",
          sortable: true,
        },
        {
          key: "eliminar",
          label: "Acciones",
          sortable: true,
        },
      ],
      listaAgregar: {
        idTratamiento: null,
        idDiente: null,
        idAdlNnMix: null,
        idPresuntivo: null,
        idKit: null,
      },
      dragging: false,

      opcionesPti: [
        {
          value: 1,
          text: "I",
        },
        {
          value: 2,
          text: "II",
        },
        {
          value: 3,
          text: "III",
        },
      ],
      selected: null,
      loaderAcciones: false,
      loader: false,
      loadingTiposPadecimientos: false,
      loadingDientes: false,
      loadingTratamientos: false,

      listaTiposPadecimiento: [],
      listaDientes: [],
      listaTratamientos: [],

      listaKits: [],

      tratamientosDiente: [],
      datosTratamientos: [],

      datosTabla: [],
      fields: [],
      paginaActual: 1,
      show: false,
      tituloModal: "",

      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null,
        obtenerTagEtapa: false,

      },

      padecimiento: {
        idPadecimiento: null,
        descripcion: null,
        regristroActivo: null,
        inpacto: null,
        valor: null,
        od: null,
        cuadrante: null,
        arcada: null,
        boca: null,
        ordenAparicion: null,
        ortodoncia: null,
        validacion: false,
        tipoDenticion: [],
        idDenticion: null,
        listaTxD: [],
        consecuenciaList: [],
        limitarClasificacion: false,
      },

      idTratamientoAgregar: null,
      fieldsDienteVistaModal: [],
      fieldsDientes: [
        {key: "idDiente", label: "Diente", sortable: true},
        {key: "idDenticion", label: "Niño / Adulto ", sortable: true},
        {key: "grupo", label: "Presuntivo I, II, III", sortable: true},
        {key: "eliminar", label: "Eliminar"},
        {key: "agregar", label: "Agregar"},
      ],
      datosDenticionArray:[],
      tipoDenticion: [], //Array tipo Denticion dinámico
      opciones: [],
      currentPadecimiento: null,

      arrayPadecimientoMotivoTagEtapa: [],

      idTipoTag: null,
      idTagMotivoCita: null,
      tagmotivocitaDatosArrayOriginal: [],
      tipoTagDatosArray: [],
      tagmotivocitaDatosArray: [],
      idEtapa: null,
      idClasificacionClinica: null,
      datosFasesArray: [],
      datosEtapasArray: [],
      clasificacionClinicas: [],
      clasificacionLimitada: [],
      idDenticion: null,
      descripcion: "",
      modalEsAgregar: null,
      modalAgregarPresuntivo: null,
      mostrarModalTratamientoNuevo: false,

      enabled: true,
      modalModificar: false,
      tratamientoSeleccionadoBase: null,
      presuntivoSeleccionado: null,
      tratamientoSeleccionado: {
        idTratamiento: null,
        nombreTratamiento: null,
        tratamiento: null,
        dientes: null,
        tipoDenticion: null,
        idPresuntivo: null,
        denticion: null,
        idKit: null,
        listaTratamientos: [],
        collapseOpen: false,
      },
    };
    // fin return
  },
  validations: {
    padecimiento: {
      descripcion: {required},
      regristroActivo: {},
      inpacto: {numeric},
      od: {},
      cuadrante: {},
      arcada: {},
      boca: {},
      ortodoncia: {},
      validacion: {required},
    },
  },
  computed: {
    cargando: function () {
      return (
          this.loaderAcciones ||
          this.loader ||
          this.loadingTiposPadecimientos ||
          this.loadingDientes ||
          this.loadingTratamientos
      );
    },
    draggingInfo() {
      return this.dragging ? "En Movimiento" : "";
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.camposTabla();
    this.obtenerPadecimientos();
    this.obtenerTipoPadecimiento();
    this.obtenerTratamientos();
    this.obtenerDientes();
    this.tipoTag();
    this.obtenerEtapas();
    this.obtenerClasificacionClinica();
    this.obtenerTipoDenticion();
  },
  watch: {

    /*idTipoTag: function (idTipoTag) {
      this.idTagMotivoCita = null;
      this.tagmotivocitaDatosArray =
          this.tagmotivocitaDatosArrayOriginal.filter(
              (element) => (element.idTipoDenticion == this.idDenticion || this.idDenticion == 3)
                  && element.idTipoTag == idTipoTag
          );

    },
    idDenticion: function (idDenticion) {
      this.idTagMotivoCita = null;
      this.tagmotivocitaDatosArray =
          this.tagmotivocitaDatosArrayOriginal.filter(
              (element) => (element.idTipoDenticion == idDenticion || idDenticion == 3)
                  && element.idTipoTag == this.idTipoTag
          );
    }*/
  },
  methods: {

    removeAt(idx) {
      this.list.splice(idx, 1);
    },


    AgregarLista() {
      this.mostrarModalTratamientoNuevo = false;
      this.listaAgregar.idPresuntivo.forEach(l => {
        this.fieldsDienteVistaModal.forEach(f => {
          if (l === f.presuntivo) {
            f.tratamientos.push({
              idTratamiento: this.listaAgregar.idTratamiento,
              nombreTratamiento: this.listaAgregar.nombreTratamiento,
              dientes: this.listaAgregar.idDiente,
              idDenticion: this.listaAgregar.idAdlNnMix.idTip,
              denticion: this.listaAgregar.idAdlNnMix.text,
              idKit: this.listaAgregar.idKit != undefined ? this.listaAgregar.idKit : null,
              listaTratamientos: this.listaAgregar.idKit != undefined ? this.listaAgregar.listaTratamientos : null,
              collapseOpen: false,
            })
          }
        })
      })
    },

    modalTratamientoNuevo() {
      this.listaAgregar =  {
        idTratamiento: null,
        idDiente: null,
        idAdlNnMix: null,
        idPresuntivo: null,
      };
      this.mostrarModalTratamientoNuevo = true
    },


    camposTabla() {
      this.fields = [
        {key: "idPadecimiento", label: "ID", sortable: true},
        {key: "descripcion", label: "Padecimientos", sortable: true},
        {key: "tipoPadecimiento", label: "Tipo", sortable: true},
        {key: "inpacto", label: "Impacto", sortable: true},
        {key: "valor", label: "Valor", sortable: true},
        {
          key: "od",
          label: "Por diente",
          sortable: true,
          formatter: this.$formatoSINOFuncion,
        },
        {
          key: "validacion",
          label: "Requerido",
          sortable: true,
          formatter: this.$formatoSINOFuncion,
        },
        {key: "listaPx", label: "Tratamientos", sortable: true},
        "Acciones",
      ];
    },
    obtenerTipoDenticion() {
      this.$http.get(this.$api + "catalogos/padecimientos/obtener/tipo/denticion")
          .then((r) => {
            if (r.data.data) {
              this.datosDenticionArray = r.data.data
              const aux = r.data.data
              aux.forEach(t => {
                this.tipoDenticion.push({
                  idTip: t.idDenticion,
                  text: t.descripcion
                })
              })

            }
          }).finally(() => {
        this.obtenerPadecimientos();
      })
    },
    obtenerPadecimientos() {
      this.datosTabla = [];
      this.loader = true;
      this.$http
          .post(this.$api + "catalogos/padecimientos/obtener", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    obtenerTipoPadecimiento() {
      this.loadingTiposPadecimientos = true;
      this.listaTiposPadecimiento = [];
      this.$http
          .get(this.$api + "catalogos/obtenerTipoPadecimiento")
          .then((response) => {
            if (response.data.data) {
              this.listaTiposPadecimiento = response.data.data;
            }
          })
          .finally(() => (this.loadingTiposPadecimientos = false));
    },
    obtenerTratamientos() {
      this.loadingTratamientos = true;
      this.listaTratamientos = [];
      this.listaKits = [];
      this.$http
          .get(this.$api + "tratamientos/datosBasicosTrtsKits")
          .then((response) => {
            if (response.data.data) {
              this.listaTratamientos = response.data.data.listaTratamientos;
              this.listaKits = response.data.data.listaKits;
            }
          })
          .finally(() => (this.loadingTratamientos = false))

    },
    obtenerDientes() {
      this.loadingDientes = true;
      this.listaDientes = [];
      this.$http
          .get(this.$api + "catalogos/listaDientes")
          .then((response) => {
            if (response.data.data) {
              this.listaDientes = response.data.data;
              this.opciones = response.data.data.sort(function (a) {
                if (a.numeroDiente === 0) {
                  return 1;
                }
                if (a.numeroDiente > 0) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              }).map(function (item) {
                var data = {
                  text: item.numeroDiente !== 0 ? item.numeroDiente : item.nombre,
                  idDiente: item.idDiente,
                  idDenticion : item.idDenticion
                };
                return data;
              });

              this.opciones.push({
                text: "Todos los dientes",
                idDenticion : 3,
                idDiente: null,
              });
            }
          })
          .finally(() => (this.loadingDientes = false));
    },
    agregar() {
      this.modalEsAgregar = true;
      this.fieldsDienteVistaModal = [
        {
          presuntivo: 1,
          tratamientos: []
        },
        {
          presuntivo: 2,
          tratamientos: []
        },
        {
          presuntivo: 3,
          tratamientos: []
        },
      ]
      this.$nextTick(() => {
        this.$v.$reset();
      });

      this.idTratamientoAgregar = null;
      this.padecimiento = {
        idPadecimiento: null,
        descripcion: null,
        regristroActivo: null,
        inpacto: 1, // ? preguntar
        valor: null,
        od: null,
        cuadrante: null,
        arcada: null,
        boca: null,
        ordenAparicion: null,
        ortodoncia: null,
        validacion: false,
        tipoDenticion: [],
        idDenticion: null,
        listaTxD: [],
        limitarClasificacion: false,
      };
      this.tituloModal = "Nuevo tratamiento";
      this.show = true;

      this.limpiarDatosFormularioAgregarMotivoEtapa();
    },

    agregarTratamiento() {
      if (this.idTratamientoAgregar !== null) {
        var contadorTratamientos = 0;
        contadorTratamientos = this.padecimiento.listaTxD.filter(
            (item) => item.idTratamiento == this.idTratamientoAgregar
        );

        if (contadorTratamientos == 0) {
          // ! Agregar tratamiento nuevo
          this.padecimiento.listaTxD.push({
            idTratamiento: this.idTratamientoAgregar,
            nombreTratamiento: this.listaTratamientos.find(
                (i) => i.idTratamiento === this.idTratamientoAgregar
            ).nombre,
            grupo: null,
            idDenticion: null,
            dientes: [],
          });
          // this.reloadArray();
        } else {
          miniToastr.warn("No puedes guardar tratamientos duplicados");
        }
      }
      this.idTratamientoAgregar = null;
    },
    seleccionarDientes(t, activar) {
      t.dientes.forEach((d) => {
        d.registroActivo = activar;
      });
    },
    guardar() {
      this.$v.padecimiento.$touch();

      if (this.$v.padecimiento.$anyError) {
        return;
      }

      if(this.padecimiento.limitarClasificacion){
        let validacion = false;
        this.arrayPadecimientoMotivoTagEtapa.forEach(motivo=>{
          if(motivo.idClasificacionClinica == 2){
            validacion = true;
          }
        })

        if(validacion){
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "El padecimiento tiene limitada su clasificación, cambie la clasificación de los motivos o desactive la limitación",
          });
          return
        }
      }



      const datosGuardar = JSON.parse(JSON.stringify(this.padecimiento));
      // const datosVerificar = JSON.parse(JSON.stringify(this.padecimiento));

      // !! VALIDAR SI ESTAN LOS DIENTES SELECCIONADOS

      // if (!this.$v.padecimiento.$invalid && !tratamientosRepetidos) {
      if (!this.$v.padecimiento.$invalid) {
        this.loaderAcciones = true;

        datosGuardar.presuntivos = this.fieldsDienteVistaModal;

        datosGuardar.presuntivos.forEach(p => {
          p.tratamientos.forEach((t, i) => {
            if (t !== null) {
              t.denticion = 1
              t.orden = i;
            }
          })
        })

        //guardamos la fase y etapa del padecimiento
        datosGuardar.padecimientoTagEtapaLista = this.arrayPadecimientoMotivoTagEtapa;
        //datosGuardar.idClasificacionClinica = this.idClasificacionClinica


          this.$http
              .post(this.$api + "catalogos/padecimientos/guardar", datosGuardar)
              .then((respuesta) => {

                this.obtenerPadecimientos();
                this.show = false;
                this.$swal.fire({
                  icon: "Success",
                  title: respuesta.data.message,
                });
                this.mostrarModalTratamientoNuevo = false;
                this.arrayPadecimientoMotivoTagEtapa = [];
              })
              .catch((error) => {
                console.error(error.response.data.message);
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: error.response.data.message,
                });
              })
              .finally(() => {
                this.obtenerTratamientos();
                this.loaderAcciones = false;

              });
        }

    },
    modificar(item) {

      this.modalEsAgregar = false;
      this.currentPadecimiento = item;
      this.$nextTick(() => {
        this.$v.$reset();
      });

      this.loader = true;

      const filtro = {
        id: item.idPadecimiento,
        palabraClave: null,
        registroActivo: null,
        obtenerTagEtapa: true,
      };
      this.$http
          .post(this.$api + "catalogos/padecimientos/obtener", filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.padecimiento = respuesta.data.data[0];
              this.fieldsDienteVistaModal = this.padecimiento.presuntivos;

              if (this.padecimiento.presuntivos !== undefined) {
                this.padecimiento.presuntivos.forEach(itp=>{
                  if (itp !== null && itp.dientes !== undefined
                  && itp.dientes !== null) {
                    itp.dientes.forEach(itptt=>{
                      itptt.dientes = [];
                      if (itptt.dientes != undefined && itptt.dientes !== null) {
                        itptt.dientes = itptt.dientes.map(it => it.idDiente)
                      }
                    })
                  }
                })
              }

              let dat = Object.values(respuesta.data.data[0].padecimientoTagEtapaLista);
              this.arrayPadecimientoMotivoTagEtapa = dat;

              if (item.bloqueoSistema !== undefined && item.bloqueoSistema !== null && item.bloqueoSistema) {
                this.tituloModal = "Consultar padecimiento: " + item.descripcion;
              } else {
                this.tituloModal = "Modificar padecimiento: " + item.descripcion;
              }
              this.show = true;
            }
          })
          .finally(() => {
            this.loader = false;
            this.obtenerTratamientos();
            this.limpiarDatosFormularioAgregarMotivoEtapa();
          });
    },
    // reloadArray() {
    //   this.padecimiento.listaTxDClon = JSON.parse(
    //       JSON.stringify(this.padecimiento.listaTxD)
    //   );
    //   this.padecimiento.listaTxDClon = _.chain(this.padecimiento.listaTxDClon)
    //       .groupBy("idTratamiento")
    //       .map((value) => ({
    //         nombreTratamiento: value[0]["nombreTratamiento"],
    //         dientes: _.chain(value)
    //             .map((valueD) => ({
    //               idDiente: valueD["idDiente"],
    //               idDenticion: valueD["idDenticion"],
    //               grupo: valueD["grupo"],
    //               disabled: false,
    //               idTratamiento: valueD["idTratamiento"],
    //               idPadecimentoTratamiento: valueD["idPadecimentoTratamiento"],
    //               idPadecimiento: this.padecimiento.idPadecimiento,
    //
    //             },
    //                     this.fieldsDienteVistaModal = JSON.parse(
    //                         JSON.stringify(
    //                             _.chain(this.padecimiento.listaTxDClon)
    //                                 .groupBy("nombreTratamiento")
    //                                 .map((value) => ({
    //                                   name: value[0]["nombreTratamiento"],
    //                                   idDiente: _.chain(value).map((valueE) => ({
    //                                     idDientes: valueE["idDiente"],
    //                                     idDenticion: valueE["idDenticion"],
    //                                   })),
    //                                   grupo: valueD["grupo"]
    //                                 }))))
    //                   ),
    //             )
    //             .value(),
    //       }))
    //       .value();
    //
    //
    //   this.$forceUpdate();
    // },
    agregarRegistro(item, nombreTrt) {
      var data = {
        grupo: 1,
        idDiente: null,
        idPadecimentoTratamiento: null,
        idPadecimiento: item.idPadecimiento,
        idTratamiento: item.idTratamiento,
        idDenticion: null,
        nombreTratamiento: nombreTrt,
        registroActivo: true,
      };
      this.padecimiento.listaTxD.push(data);

      // this.reloadArray();
    },
    eliminarRegistro(itemEliminado) {
      if (itemEliminado.idPadecimentoTratamiento != null) {
        itemEliminado.disabled = true;
        this.$swal.fire({
          title: "¿Estás seguro de borrar el registro?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.$http
                .post(
                    this.$api +
                    "catalogos/padecimientos/desactivarRelacion?idPadecimientoTratamiento=" +
                    itemEliminado.idPadecimentoTratamiento
                )
                .then(() => {
                  this.$swal({
                    icon: "success",
                    title: "Se elimino correctamente",
                    showConfirmButton: false,
                    timer: 2500,
                  });
                })
                .finally(() => {
                  itemEliminado.disabled = false;
                  this.modificar(this.currentPadecimiento);
                });
          },
          allowOutsideClick: () => {
            !this.$swal.isLoading();
            itemEliminado.disabled = false;
          },
        });
      } else {
        this.modificar(this.currentPadecimiento);
      }
    },
    eliminar(item) {
      const mensaje = item.registroActivo
          ? "¿Está seguro de desactivar el padecimiento?"
          : "¿Está seguro de activar el padecimiento?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          let url = "activar";
          if (item.registroActivo) {
            url = "desactivar";
          }
          const params = {
            idPadecimiento: item.idPadecimiento
          }
          this.$http
              .post(
                  this.$api +
                  "catalogos/padecimientos/" +
                  url, params)
              .then((respuesta) => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El padecimiento se actualizó correctamente",
                  });
                }
              });
        }
      });
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.padecimiento[name];
      return $dirty ? !$error : null;
    },
    cerrarModal() {
      this.show = false;
      //this.idTipoTag = null;
      this.idTagMotivoCita = null;
      this.arrayPadecimientoMotivoTagEtapa = [];
    },
    cerrarModalTratamientos() {
      this.mostrarModalTratamientoNuevo = false;
      this.modalModificar = false;
      //this.idTipoTag = null;
      this.idTagMotivoCita = null;
      this.arrayPadecimientoMotivoTagEtapa = [];
    },
    tipoTag() {
      this.tipoTagDatosArray = [];

      this.$http
          .get(this.$api + "tagmotivocita/tipotag")
          .then((response) => {
            this.tipoTagDatosArray = response.data.data;
          })
          .finally(() => {
            this.tagMotivoCita();
          });
    },
    tagMotivoCita() {
      this.tagmotivocitaDatosArrayOriginal = [];

      this.$http
          .get(this.$api + "tagmotivocita/tagmotivocita")
          .then((response) => {
            this.tagmotivocitaDatosArrayOriginal = response.data.data;
            this.tagmotivocitaDatosArray = this.tagmotivocitaDatosArrayOriginal.filter((element) => 
              (element.idTipoDenticion == 2)
            );
          });
    },
    obtenerEtapas() {
      this.datosEtapasArray = [];
      this.$http
          .get(this.$api + "padecimientotagetapa/obteneretapas")
          .then((response) => {
            this.datosEtapasArray = response.data.data;
          });
    },
    obtenerClasificacionClinica() {
      this.clasificacionClinicas = [];
      this.$http
          .get(this.$api + "catalogos/obtenerClasificacionClinica")
          .then((response) => {
            this.clasificacionClinicas = response.data.data;
            this.clasificacionLimitada = JSON.parse(JSON.stringify(response.data.data))
            this.clasificacionLimitada = this.clasificacionLimitada.filter(cl=>cl.idClasificacionClinica == 1);
          });
    },

    agregarElementosAlSArrayPadecimientoMotivoTagEtapa(
        //letIdTipoTag,
        letIdTagMotivoCita,
        letIdClasificacionClinica,
        //letIdDenticion
    ) {
      if (
          //letIdTipoTag != null &&
          letIdTagMotivoCita != null &&
          letIdClasificacionClinica != null //&&
          //letIdDenticion != null
      ) {
        let existe = null;
        existe = this.arrayPadecimientoMotivoTagEtapa.filter(function (item) {
          return item.idTagMotivoCita === letIdTagMotivoCita
              && item.idClasificacionClinica === letIdClasificacionClinica;
        });

        let clasiLim = false;
        if(this.padecimiento.limitarClasificacion){
          clasiLim = letIdClasificacionClinica == 2 ? true : false;
        }

        let motivoCita = this.tagmotivocitaDatosArrayOriginal.filter(function (
            item
        ) {
          return item.idTagMotivoCita == letIdTagMotivoCita;
        });
        motivoCita = Object.values(motivoCita);


        let clasi = this.clasificacionClinicas.filter(function (item) {
          return item.idClasificacionClinica == letIdClasificacionClinica;
        });
        clasi = Object.values(clasi);


        if(clasiLim){
          miniToastr.warn("La clasificación esta limitada, cambia la clasificacion a prioridad clinica");
        }else{
          if (existe.length == 0) {
            this.arrayPadecimientoMotivoTagEtapa.push({
              idPadecimientoTagEtapa: null,
              idTagMotivoCita: letIdTagMotivoCita,
              nombreMotivoCita: motivoCita[0].descripcionTagMotivoCita,
              idClasificacionClinica: letIdClasificacionClinica,
              nombreClasificacion: clasi[0].clasificacionClinica,
              registroActivo: true,
            });

            this.limpiarDatosFormularioAgregarMotivoEtapa();

          } else {
            miniToastr.warn("Ya existe con el Motivo Cita seleccionado");
          }
        }
      }
    },
    eliminarElementosAlSArrayPadecimientoMotivoTagEtapa(item) {

      const indiceEliminar = this.arrayPadecimientoMotivoTagEtapa.findIndex(filtro =>
          //filtro.idTipoTag == item.idTipoTag
          //&& filtro.idDenticion === item.idDenticion && 
          filtro.idTagMotivoCita === item.idTagMotivoCita
          && filtro.idClasificacionClinica === item.idClasificacionClinica
      );

      this.arrayPadecimientoMotivoTagEtapa.splice(indiceEliminar, 1);
    },
    limpiarDatosFormularioAgregarMotivoEtapa() {
      //this.idTipoTag = null;
      this.idTagMotivoCita = null;
      this.idClasificacionClinica = null;
      //this.idDenticion = null;
    },
    eliminarLista(p, t) {
      this.$swal.fire({
        title: "¿Estás seguro de borrar el registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          p.tratamientos.splice(p.tratamientos.indexOf(t), 1);
        }
      })
    },
    modificarTratamiento(p, item) {
      this.tratamientoSeleccionadoBase = item;
      this.presuntivoSeleccionado = p;

      this.tratamientoSeleccionado = {
        tratamiento: {
          "idTratamiento": item.idTratamiento,
          "nombreTratamiento": item.nombreTratamiento
        },
        dientes: item.dientes,
        tipoDenticion: {
          "idTip": item.idDenticion,
          "text": item.denticion
        },
        idPresuntivo: p.presuntivo,
        idKit: item.idKit,
        listaTratamientos: item.listaTratamientos,
        collapseOpen: false,
      }
      this.modalModificar = true;
    },
    actualizarRegistro() {
      if (this.presuntivoSeleccionado.presuntivo === this.tratamientoSeleccionado.idPresuntivo) {
        const index = this.fieldsDienteVistaModal[this.tratamientoSeleccionado.idPresuntivo - 1].tratamientos.indexOf(this.tratamientoSeleccionadoBase)
        this.presuntivoSeleccionado.tratamientos[index] = {
          idTratamiento: this.tratamientoSeleccionado.tratamiento.idTratamiento,
          nombreTratamiento: this.tratamientoSeleccionado.tratamiento.nombreTratamiento,
          dientes: this.tratamientoSeleccionado.dientes,
          idDenticion: this.tratamientoSeleccionado.tipoDenticion.idTip,
          denticion: this.tratamientoSeleccionado.tipoDenticion.text,
          
          idKit: this.tratamientoSeleccionado.tratamiento.idKit,
          listaTratamientos: this.tratamientoSeleccionado.tratamiento.listaTratamientos,
          collapseOpen: false,
        };


      } else {
        this.fieldsDienteVistaModal[this.presuntivoSeleccionado.presuntivo - 1].tratamientos.splice(this.fieldsDienteVistaModal[this.presuntivoSeleccionado.presuntivo - 1].tratamientos.indexOf(this.tratamientoSeleccionadoBase));

        this.fieldsDienteVistaModal[this.tratamientoSeleccionado.idPresuntivo - 1].tratamientos.push(
            {
              idTratamiento: this.tratamientoSeleccionado.tratamiento.idTratamiento,
              nombreTratamiento: this.tratamientoSeleccionado.tratamiento.nombreTratamiento,
              dientes: this.tratamientoSeleccionado.dientes,
              idDenticion: this.tratamientoSeleccionado.tipoDenticion.idTip,
              denticion: this.tratamientoSeleccionado.tipoDenticion.text,
              
              idKit: this.tratamientoSeleccionado.tratamiento.idKit,
              listaTratamientos: this.tratamientoSeleccionado.tratamiento.listaTratamientos,
              collapseOpen: false,
            }
        )
      }
      this.modalModificar = false
    },
  },
};
</script>
<style scoped>
.flxOpciones {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.modal {
  margin: 30px;
  padding: 0px;
  background: rgba(0, 0, 0, 0.4);
}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
